export default {
  id: "customTrendingProductDown",
  name: "",
  description: "",
  report: {
    name: "Trending Down",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "SaleItem",
      dimensions: ["Product.name"],
      measures: [
        "SaleItem.current_month_units_sold",
        "SaleItem.previous_month_units_sold",
        "SaleItem.month_over_month_percent_change",
      ],
      sort: {
        direction: "asc",
        by: "SaleItem.month_over_month_percent_change",
      },
      timeDimension: "SaleItem.sale_time",
      timeDateRange: "last month",
      applyDateRangeFilter: false,
      filterDateRange: false,
      filters: [
        {
          member: "SaleItem.month_over_month_percent_change",
          operator: "lt",
          values: [0],
        },
      ],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
